// @flow

import * as React from 'react';
import { createFragmentContainer, graphql } from 'react-relay/compat';
import JobEvent from '../JobEvent';
import type { JobEventChanged_event } from './__generated__/JobEventChanged_event.graphql';

type Props = {
  event: JobEventChanged_event,
  previousTimestamp: ?string
};

function JobEventChanged({ event, previousTimestamp }: Props) {
  return (
    <JobEvent timestamp={event.timestamp} previousTimestamp={previousTimestamp}>
      <JobEvent.Label>
        Job Changed
      </JobEvent.Label>
      <JobEvent.Content>
        <pre>{JSON.stringify(event, null, 4)}</pre>
      </JobEvent.Content>
    </JobEvent>
  );
}

export default createFragmentContainer(JobEventChanged, {
  event: graphql`
    fragment JobEventChanged_event on JobEvent {
      ... on JobEvent {
        timestamp
      }
    }
  `
});
